/*
 * Nasze reklamy (sections/reklamy.liquid).
 *
 * Od 2026-09-29: wszystkie filmy sekcji grają NARAZ, wyciszone, w pętli,
 * bez żadnego UI. Start, gdy sekcja wjedzie w ekran (IntersectionObserver);
 * po wyjechaniu pauza (nie mielimy dekodera poza ekranem), po powrocie
 * grają dalej. Pierwszy start od zera, więc wszystkie ruszają równo.
 *
 * Włączamy tylko widoczną wersję (pozioma / pionowa — CSS chowa drugą
 * przez display:none). Ukryta zostaje z preload="none", więc jej plik
 * się nie pobiera. Zmiana szerokości okna (obrót telefonu) przelicza.
 *
 * Gra KAŻDEMU — także przy prefers-reduced-motion (decyzja usera).
 * Bez YouTube: tylko pliki <video>.
 */
(function () {
  if (window.__reklamyStrony) return;
  window.__reklamyStrony = true;

  function widoczny(el) {
    return el.getClientRects().length > 0;
  }

  // Plakat z data-poster → poster, tylko dla widocznej wersji filmu
  // (sekcja podaje go leniwie — patrz komentarz w reklamy.liquid).
  function plakaty(sekcja) {
    var boxy = sekcja.querySelectorAll('.reklama__odtwarzacz');
    for (var i = 0; i < boxy.length; i++) {
      var v = boxy[i].querySelector('video[data-poster]');
      if (!v || !widoczny(boxy[i])) continue;
      v.setAttribute('poster', v.getAttribute('data-poster'));
      v.removeAttribute('data-poster');
    }
  }

  function graj(sekcja) {
    plakaty(sekcja);
    var boxy = sekcja.querySelectorAll('.reklama__odtwarzacz');
    for (var i = 0; i < boxy.length; i++) {
      var box = boxy[i];
      var v = box.querySelector('video');
      if (!v) continue;
      if (!widoczny(box)) {
        if (!v.paused) v.pause();
        continue;
      }
      v.muted = true;
      if (v.preload === 'none') v.preload = 'auto';
      if (!v.paused) continue;
      var p = v.play();
      if (p && p.then) {
        p.then(
          (function (b) {
            return function () {
              b.classList.add('jest-odtwarzany');
            };
          })(box),
          function () {}
        );
      }
    }
  }

  function pauzuj(sekcja) {
    var filmy = sekcja.querySelectorAll('.reklama__wideo');
    for (var i = 0; i < filmy.length; i++) {
      if (!filmy[i].paused) filmy[i].pause();
    }
  }

  var naEkranie = [];

  function blisko(el) {
    var r = el.getBoundingClientRect();
    var h = window.innerHeight;
    return r.bottom > -1.5 * h && r.top < 2.5 * h;
  }

  var obserwator =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (wpisy) {
            for (var i = 0; i < wpisy.length; i++) {
              var s = wpisy[i].target;
              var idx = naEkranie.indexOf(s);
              if (wpisy[i].isIntersecting) {
                if (idx < 0) naEkranie.push(s);
                graj(s);
              } else {
                if (idx >= 0) naEkranie.splice(idx, 1);
                pauzuj(s);
              }
            }
          },
          { threshold: 0.25 }
        )
      : null;

  // Plakaty wczytujemy z zapasem ~1,5 ekranu, żeby przy zwykłym
  // przewijaniu były gotowe, zanim sekcja wjedzie.
  var obserwatorPlakatow =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (wpisy) {
            for (var i = 0; i < wpisy.length; i++) {
              if (!wpisy[i].isIntersecting) continue;
              plakaty(wpisy[i].target);
              obserwatorPlakatow.unobserve(wpisy[i].target);
            }
          },
          { rootMargin: '150% 0px' }
        )
      : null;

  function podepnij() {
    var sekcje = document.querySelectorAll('.reklamy');
    for (var i = 0; i < sekcje.length; i++) {
      if (sekcje[i].__reklamyPodpiete) continue;
      sekcje[i].__reklamyPodpiete = true;
      if (obserwatorPlakatow) obserwatorPlakatow.observe(sekcje[i]);
      if (obserwator) obserwator.observe(sekcje[i]);
      else graj(sekcje[i]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', podepnij);
  else podepnij();

  // Obrót telefonu / zmiana szerokości: może się zmienić widoczna wersja
  var czasResize;
  window.addEventListener('resize', function () {
    clearTimeout(czasResize);
    czasResize = setTimeout(function () {
      for (var i = 0; i < naEkranie.length; i++) graj(naEkranie[i]);
      var wszystkie = document.querySelectorAll('.reklamy');
      for (var j = 0; j < wszystkie.length; j++) {
        if (wszystkie[j].querySelector('video[data-poster]') && blisko(wszystkie[j])) plakaty(wszystkie[j]);
      }
    }, 200);
  });

  // Karta w tle: przeglądarka i tak dławi wideo, a po powrocie wznawiamy
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) return;
    for (var i = 0; i < naEkranie.length; i++) graj(naEkranie[i]);
  });

  // Edytor motywu: przeładowana sekcja to nowy DOM — podpinamy od nowa
  document.addEventListener('shopify:section:load', podepnij);
  document.addEventListener('shopify:section:unload', function (e) {
    var s = e.target && e.target.querySelector && e.target.querySelector('.reklamy');
    if (!s) return;
    pauzuj(s);
    if (obserwator) obserwator.unobserve(s);
    var idx = naEkranie.indexOf(s);
    if (idx >= 0) naEkranie.splice(idx, 1);
  });
})();
